// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3tg1M","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3kwZz"};